/**
 * Location Type
 *
 * "Nearby" is a location where you return to the reporting site at EOD
 * "Distant" is a location that requires an overnight stay
 */
export enum LocationType {
  Studio = 'Studio',
  Nearby = 'Nearby',
  Distant = 'Distant',
  Airport = 'Airport',
}

/**
 * Airports
 */
export enum Airport {
  LaGuardia = 'LaGuardia',
  JFK = 'JFK',
  Newark = 'Newark',
  LAX = 'LAX',
}

/**
 * Studio Zones
 */
export enum StudioZone {
  NewYork = 'New York',
  NewYorkCity = 'New York City',
  LosAngeles = 'Los Angeles',
}
